import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useAppContext } from "../../hooks/context/AppContext";
import { useHeader } from "../../hooks/context/HeaderContext";
import cordilleraLogo from "../../assets/images/cordillera-logo.png"; // Adjust path based on header.tsx location
import CustomHomeIcon from "../Icons/CustomHomeIcon";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";

interface HeaderProps {
  roleAvailable: boolean;
  headerText: string;
  landingPage: boolean;
}

const Header: React.FC<HeaderProps> = ({
  roleAvailable,
  headerText,
  landingPage,
}) => {
  const { userData, userInitialized } = useAppContext();
  const {
    submittedBy,
    submittedDate,
    signOffBy,
    signOffDate,
    landscapeName,
    commentStatus,
    refreshDate,
  } = useHeader();
  const location = useLocation();

  const formatDate = (value?: string) => {
    if (!value) return "";
    const d = dayjs(value);
    if (!d.isValid()) return String(value);
    return d.format("DD/MM/YYYY HH:mm");
  };

  useEffect(() => {}, [submittedBy, submittedDate]);
  if (!userInitialized) {
    return (
      <Box bgcolor="#0094f2" py={2} px={2}>
        <Typography color="white">Loading user info...</Typography>
      </Box>
    );
  }

  return (
    <div className="header-bar">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: "#0094f2",
          borderRadius: "0px 0px 20px 20px",
          margin: "0px 2px",
          boxShadow: "0px 2px 4px 0px #12239E;",
          py: 0.5,
          px: 1,
          color: "white",
        }}
      >
        <Box
          sx={{
            cursor:
              location.pathname !== "/" &&
              location.pathname.toLowerCase() !== "/home"
                ? "pointer"
                : "",
            display: "flex",
            alignItems: "center",
          }}
          onClick={
            location.pathname !== "/" &&
            location.pathname.toLowerCase() !== "/home"
              ? () => (window.location.href = "/")
              : undefined
          }
        >
          {location.pathname !== "/" &&
            location.pathname.toLowerCase() !== "/home" && <CustomHomeIcon />}
          <Box>
            <Box className="display-logo"
              sx={{
              
                position: "relative",
                backgroundColor: "#0094f2",
                borderRadius: "0 0 20px 20px",
                display: "flex",
                alignItems: "center",
                height: "40px", // adjust to match logo height
                width: "fit-content",
              }}
            >
              <img src={cordilleraLogo} alt="Logo" style={{ height: "40px" }} />
              <Box
                sx={{
                  position: "absolute",
                  top: "52%",
                  left: "40px", // offset to the right of logo
                  transform: "translateY(-50%)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  minWidth: "200px",
                  whiteSpace: "nowrap",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "22px !important",
                    pt: "0px",
                    lineHeight: 1,
                    marginBottom: "0px",
                  }}
                >
                  {landscapeName}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.9rem", // ~14px
                    mt: "-3px",
                    color: "#71f0f5",
                  }}
                >
                  BALANCE SHEET {headerText}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {roleAvailable && !landingPage && (
          <Typography
            sx={{
              display: "flex",
              textAlign: "left",
              fontSize: "0.8rem",
              mt: "0px",
              mb: "0px",
            }}
          >
            {/* Comments Updated Date & Time: April 05 2024 10:00 AM(UTC) */}
            <div className="app-header">
              <div className="header-section">
                <span className="label">Submitted By:</span> {submittedBy}{" "}
                <br></br>
                <span className="label">Submitted Date (UTC):</span> {formatDate(submittedDate)}
              </div>
            </div>
            <div className="app-header">
              <div className="header-section1">
                <span className="label">Signed off By:</span> {signOffBy}{" "}
                <br></br>
                <span className="label ">Signed off Date (UTC):</span> {formatDate(signOffDate)}
              </div>
            </div>
            <div className="app-header">
              {/* <div className="header-section1">

                  <span className="label preparerCommentsStatus">
                    Comment Status:</span>
                  <br></br>
                  <span className="signedOff">{commentStatus}</span>
                </div> */}

              <div className="header-section1">
                <span className="label preparerCommentsStatus">
                  Comment Status:
                </span>
                <br></br>
                {commentStatus && (
                  <span className="signedOff">{commentStatus}</span>
                )}
              </div>
            </div>

            <div className="app-header">
              <div className="header-section1">
                <span className="label preparerCommentsStatus">
                  Latest Refresh Date (UTC):
                </span>
                <br></br>
                {refreshDate && (
                  <span className="signedOff">{formatDate(refreshDate)}</span>
                )}
              </div>
            </div>
          </Typography>
        )}
        <Box className="userProfileName" sx={{ display: "flex" }}>
          <Typography
            sx={{
              fontSize: "0.8rem",
              fontWeight: "bold",
              color: "white",
              marginRight: "5px",
              mt: "10px",
            }}
          >
            {userData?.FullName ? `${userData.FullName}` : "firstname.lastname"}
          </Typography>
          <div className="userprofile"></div>
        </Box>
      </Box>
    </div>
  );
};

export default Header;
